import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import loginBanner from "assets/images/landing/loginImage.svg";
import { useMediaQuery } from "@mui/material";
import AuthCardWrapper from "../../auth/AuthCardWrapper";
import AnimateButton from "ui-component/extended/AnimateButton";
import { Link } from "react-router-dom";
import loginCardbanner from "assets/images/landing/logincardbanner.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useStyles } from "../styles";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";

interface LoginSectionProps {
  activeTab: "user" | "admin";
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const LoginSection: React.FC<LoginSectionProps> = ({
  activeTab,
  handleTabChange,
}) => {
  const theme = useTheme();
  const styles = useStyles();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("sm"));
  const [registerPath, setRegisterPath] = useState("/auth/register");

  useEffect(() => {
    const token = localStorage.getItem("user-token");
    if (token) {
      setRegisterPath("/user/dashboard");
    } else {
      setRegisterPath("/auth/register");
    }
  }, []);

  const handleDownload = (item: any) => {
    const filePath = require(`assets/pdf/${item}.pdf`);

    fetch(filePath)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      })
      .catch((error) => {
        console.error("Error opening the file in new tab:", error);
      });
  };

  return (
    <Grid container xs={12} my={6} sx={{ position: { md: "relative" } }}>
      <Grid item md={9.5} sx={styles.gridItem}>
        <Grid item xl={7.7} sx={styles.loginImage}>
          <Box
            component="img"
            src={loginBanner}
            alt="Login Banner"
            sx={styles.loginBanner}
          />
        </Grid>

        <Grid m={2} xs={12} md={6} sx={styles.authCardWrapper} item>
          <AuthCardWrapper sx={styles.formBg}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12}>
                <Box>
                  <Tabs
                    value={activeTab === "user" ? 0 : 1}
                    onChange={handleTabChange}
                    centered
                    textColor="primary"
                    indicatorColor="secondary"
                    sx={styles.tabs}
                  >
                    <Tab
                      label={
                        <Typography variant="h1" sx={styles.tabLabel}>
                          User
                        </Typography>
                      }
                    />
                    <Tab
                      label={
                        <Typography variant="h1" sx={styles.tabLabel}>
                          Admin
                        </Typography>
                      }
                    />
                  </Tabs>
                </Box>
              </Grid>
              <Grid item sx={styles.form} mt={3}>
                <img src={loginCardbanner} alt="Login Card Banner" />
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.loginBtn}>
                  <AnimateButton>
                    <Button
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      color="secondary"
                      component={Link}
                      to={
                        activeTab === "user"
                          ? "/auth/user-login"
                          : "/auth/admin-login"
                      }
                    >
                      Log in
                    </Button>
                  </AnimateButton>
                </Box>
              </Grid>
              <Grid container mt={3}>
                <Grid item xs={12} sx={styles.divider}>
                  <Divider />
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    item
                    container
                    direction="column"
                    alignItems="center"
                    xs={12}
                    flexDirection={matchDownSM ? "column" : "row"}
                    justifyContent="center"
                    gap={1}
                    sx={{ display: activeTab === "user" ? "" : "none" }}
                  >
                    <Typography sx={styles.textDecorationNone}>
                      Don&apos;t have an account?
                    </Typography>
                    <Typography
                      component={Link}
                      to={registerPath}
                      variant="subtitle1"
                      sx={styles.registerLink}
                    >
                      Register
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    justifyContent="space-evenly"
                    alignItems="center"
                    mt={3}
                    spacing={2}
                  >
                    {["FAQ", "TMC Guidelines", "User Guide"].map((item) => (
                      <Grid item xs={12} sm={3} key={item}>
                        <Button
                          fullWidth
                          variant="outlined"
                          onClick={() => handleDownload(item)}
                          sx={styles.infoButton}
                          endIcon={<ArrowForwardIcon />}
                        >
                          {item}
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </AuthCardWrapper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginSection;
